import { createContext, useContext } from 'react';

// Tells AppHeader (and anything else) that the page is being drawn inside the V3 shell. null = not in V3.
//   toolbarSlot: the DOM element above the page where the page's control bar is drawn (a portal target).
export const V3ShellContext = createContext(null);

export const useV3Shell = () => useContext(V3ShellContext);

export default V3ShellContext;
